"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _SVBAPIProductMainUse = require("../../SVBAPIProductMainUse");
var _product_background = _interopRequireDefault(require("@svb/svbbranding/dist/assets/images/product_background.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SVBApiProductOwner = props => {
  var _props$backgroundImag, _props$title, _props$slogan, _props$description, _props$buttonTitle, _props$color, _props$image;
  const productImage = (_props$backgroundImag = props === null || props === void 0 ? void 0 : props.backgroundImage) !== null && _props$backgroundImag !== void 0 ? _props$backgroundImag : _product_background.default;
  const backgroundStyle = {
    backgroundImage: "url(".concat(productImage, ")")
  };
  const title = (_props$title = props === null || props === void 0 ? void 0 : props.title) !== null && _props$title !== void 0 ? _props$title : "";
  const slogan = (_props$slogan = props === null || props === void 0 ? void 0 : props.slogan) !== null && _props$slogan !== void 0 ? _props$slogan : "";
  const description = (_props$description = props === null || props === void 0 ? void 0 : props.description) !== null && _props$description !== void 0 ? _props$description : [];
  const buttonTitle = (_props$buttonTitle = props === null || props === void 0 ? void 0 : props.buttonTitle) !== null && _props$buttonTitle !== void 0 ? _props$buttonTitle : "";
  const _handleButtonPress = props === null || props === void 0 ? void 0 : props.handleButtonPress;
  const color = (_props$color = props === null || props === void 0 ? void 0 : props.color) !== null && _props$color !== void 0 ? _props$color : "green";
  const image = (_props$image = props === null || props === void 0 ? void 0 : props.image) !== null && _props$image !== void 0 ? _props$image : "";
  return /*#__PURE__*/_react.default.createElement("div", {
    style: backgroundStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container pb-6 pt-10"
  }, /*#__PURE__*/_react.default.createElement(_SVBAPIProductMainUse.SVBAPIProductMainUse, {
    title: title,
    slogan: slogan,
    description: description,
    color: "yellow",
    buttonTitle: buttonTitle,
    handleButtonPress: () => _handleButtonPress(),
    image: image,
    enableWhiteFont: true,
    buttonIconClasses: "m-1",
    buttonRightIconName: "right-disabled",
    buttonStyle: "rl-font-black"
  })));
};
var _default = SVBApiProductOwner;
exports.default = _default;